/**
 * shared pipes are export
 */
export * from './rxjs-operators';

/**
 * shared services are export
 */
export { HttpClientService } from './services/http-client.service';
export { CookieManagerService } from './services/cookie-manager.service';
export { ErrorManagerService } from './services/error-manager.service';
export { TimeService } from './services/time.service';
export { QnavigatorService } from './services/qnavigator.service';
export { CustomObserverService } from './services/custom-observable.service';
export { BasicTimerService } from './services/basic-timer.service';
export { FormValidaterService } from './services/form-validater.service';
export { GoogleService } from './services/google.service';
export { SwalService } from './services/swal.service';
export { ShoppingCartService } from './services/shopping-cart.service';
export { BackButtonService } from './services/back-button.service';
export { RegistrationFeeService } from './services/registration-fee.service';
export { RegistrationFeeTokenService } from './services/registration-fee-token.service';

export { emailValidator, matchingPasswords, mobileValidator, mobileNumberValidator, lankaBellvalidator, isValidEmail, emptyField, cvv, getCardType, cardNumber, usernameValidator, isValidEmailOrMobile, cardExpireDate, mobitelValidator, dialogEtisalatHutchValidator, dialogValidator } from './services/validator';

export { LoaderComponent } from './loader/loader.component';
export { ErrorInternetComponent } from './error-internet/error-internet.component';

/**
 * Shared pipes are export
 */
export { CurrencyPipe } from './pipe/currency.pipe';
export { OrderBy } from './pipe/orderby.pipe';
export { AnswerSelectorPipe } from './pipe/answer-selector.pipe';
export { LockPipe } from './pipe/lock.pipe';
export { PipeTransformPipe } from './pipe/pipe-transform.pipe';
export { LoginRedirectService } from './services/login-redirect.service';


// WEBPACK FOOTER //
// /usr/share/nginx/grade5_live/grade5-frontend-2.0/src/app/shared/index.ts